/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetEvidenceRecords200ResponseInnerWarnings
 */
export interface GetEvidenceRecords200ResponseInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerWarnings
     */
    'detectedDpi'?: GetEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerWarnings
     */
    'calculatedDpi'?: GetEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerWarnings
     */
    'colorGradation'?: GetEvidenceRecords200ResponseInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerWarnings
     */
    'heightMillis'?: GetEvidenceRecords200ResponseInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidenceRecords200ResponseInnerWarnings
     */
    'widthMillis'?: GetEvidenceRecords200ResponseInnerWarningsWidthMillisEnum;
}

export const GetEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum = typeof GetEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum[keyof typeof GetEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum];
export const GetEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum = typeof GetEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum[keyof typeof GetEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum];
export const GetEvidenceRecords200ResponseInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetEvidenceRecords200ResponseInnerWarningsColorGradationEnum = typeof GetEvidenceRecords200ResponseInnerWarningsColorGradationEnum[keyof typeof GetEvidenceRecords200ResponseInnerWarningsColorGradationEnum];
export const GetEvidenceRecords200ResponseInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidenceRecords200ResponseInnerWarningsHeightMillisEnum = typeof GetEvidenceRecords200ResponseInnerWarningsHeightMillisEnum[keyof typeof GetEvidenceRecords200ResponseInnerWarningsHeightMillisEnum];
export const GetEvidenceRecords200ResponseInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidenceRecords200ResponseInnerWarningsWidthMillisEnum = typeof GetEvidenceRecords200ResponseInnerWarningsWidthMillisEnum[keyof typeof GetEvidenceRecords200ResponseInnerWarningsWidthMillisEnum];


